/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { openDB } from 'idb';

const DB_NAME = 'image-cache-db';
const STORE_NAME = 'images';
export const blobUrlMap = new Map<string, string>();

const getDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    }
  });
};

export const cacheImageBlob = async (key: string, blob: Blob): Promise<string> => {
  if (!key || !blob) return '';

  const db = await getDB();
  await db.put(STORE_NAME, blob, key);

  // Revoke old URL if already exists
  if (blobUrlMap.has(key)) {
    URL.revokeObjectURL(blobUrlMap.get(key)!);
  }

  const objectUrl = URL.createObjectURL(blob);
  blobUrlMap.set(key, objectUrl);
  return objectUrl;
};

export const getCachedImageBlobUrl = async (key: string): Promise<string | null> => {
  if (!key) {
    console.warn('⚠️ getCachedImageBlobUrl called with invalid key');
    return null;
  }

  if (blobUrlMap.has(key)) return blobUrlMap.get(key)!;

  const db = await getDB();
  const blob = await db.get(STORE_NAME, key);

  if (blob instanceof Blob) {
    const objectUrl = URL.createObjectURL(blob);
    blobUrlMap.set(key, objectUrl);
    return objectUrl;
  }

  return null;
};

export const clearBlobUrlCache = () => {
  blobUrlMap.forEach((url) => URL.revokeObjectURL(url));
  blobUrlMap.clear();
};

export const clearAllImageCache = async () => {
  const db = await getDB();

  // Clear all blobs in the IndexedDB
  const tx = db.transaction(STORE_NAME, 'readwrite');
  await tx.objectStore(STORE_NAME).clear();
  await tx.done;

  // Revoke all in-memory blob URLs
  clearBlobUrlCache();
  console.log('✅ Cleared all image cache from IndexedDB and memory');
};
